import { render, staticRenderFns } from "./BaseListContent.vue?vue&type=template&id=6218d1a2&scoped=true"
import script from "./BaseListContent.vue?vue&type=script&lang=js"
export * from "./BaseListContent.vue?vue&type=script&lang=js"
import style0 from "./BaseListContent.vue?vue&type=style&index=0&id=6218d1a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6218d1a2",
  null
  
)

export default component.exports